import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutionmilo() {
  return (
    <section className="solutionmilo p-100 text_milo">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="platform_img">
              <StaticImage
                src="../../../images/case-studies/milocare/solutions.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={632}
                height={608}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>
              Solutions <span>Delivered</span>
            </h2>
            <p>
              To resolve these challenges, MiloCare+ applied a tailored solution
              for Google and Apple Wallet integration, allowing secure
              vaccination card storage within the app. Additionally, robust data
              security procedures were used, including cutting-edge encryption
              and strict observance of HIPAA guidelines.
            </p>
            <p>
              MiloCare+ feature set contains health report management, family
              health profiles, secure cloud storage, end-to-end data encoding,
              access control mechanisms, and full submission to HIPAA protocols.
              The integration of a "Next vaccination counter" improves user
              engagement by delivering valued vaccination scheduling details.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionmilo;
